const routes = [

	
	//---- "System Admin" / "Lotus Admin" pages
	{ 
		path: '/system-admin/access-definitions', 
		component: () => import("/system-admin/access-definitions.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "", pageTitle: "Feature Access Definitions" }
	},

	{ 
		path: '/system-admin/timesheet-generation', 
		component: () => import("/system-admin/timesheet-generation.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "", pageTitle: "Timesheet Generation" }
	},

	{ 
		path: '/system-admin/accounts', 
		name: "system-admin-accounts",
		component: () => import("/system-admin/accounts.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "", pageTitle: "Accounts" }
	},
	{ 
		path: '/system-admin/accounts/new', 
		name: "system-admin-accounts-new",
		component: () => import("/system-admin/account.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "system-admin-accounts", pageTitle: "Account" }
	},


	{ 
		path: '/system-admin/account/:id/edit', 
		name: "system-admin-accounts-edit",
		component: () => import("/system-admin/account.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "system-admin-accounts", pageTitle: "Edit" }
	},



	//---- Seats & Inclusions: what every seat and add-on carries (read-only; the mapping lives in code) ----
	{
		path: '/system-admin/seat-inclusions',
		name: "system-admin-seat-inclusions",
		component: () => import("/system-admin/seat-inclusions/seat-inclusions.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "", pageTitle: "Seats & Inclusions" }
	},


	//---- System messages: the notices Lotus staff target at users inside accounts ----
	{
		path: '/system-admin/system-messages',
		name: "system-admin-system-messages",
		component: () => import("/system-admin/system-messages/list-messages.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "", pageTitle: "System Messages" }
	},
	{
		path: '/system-admin/system-messages/new',
		name: "system-admin-system-messages-new",
		component: () => import("/system-admin/system-messages/message-editor.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "system-admin-system-messages", pageTitle: "New message" }
	},
	{
		path: '/system-admin/system-messages/:id',
		name: "system-admin-system-messages-edit",
		component: () => import("/system-admin/system-messages/message-editor.vue"),
		meta: { layout: "primary", section: "system-admin", module: "systemAdmin", parentRouteName: "system-admin-system-messages", pageTitle: "Edit - {messageTitle}" }
	},



	//---- API info moved to the Lotus Developers section: /developers/api-info (see
	//	   routes.developers.js). Kept as a redirect because this path has been linked to and
	//	   bookmarked; drop it once those have aged out.
	{
		path: '/system-admin/api-info',
		redirect: { name: "developers-api-info" }
	},



	{
		path: '/system-admin/review-timesheets', 	//NOTE: This is the primary version for the following 4, which should really be considered obsolete and consolidated into this one (via filters)
		component: () => import("/system-admin/timesheets/list-timesheets.vue"),
		name: "SystemAdminReviewTimesheets",
		meta: { layout: "primary", module: "systemAdmin", parentRouteName: "", pageTitle: "Review Timesheets" }
	},
	{
		path: '/system-admin/timesheets/id/:id/activity', 
		component: () => import("/system-admin/timesheets/timesheet-activity.vue"),
		name: "SystemAdminTimesheetsTimesheetActivity",
		meta: { layout: "primary", module: "systemAdmin", parentRouteName: "SystemAdminReviewTimesheets", pageTitle: "Timesheet Activity" }
	},


]


export default routes;